import React, { useMemo } from "react"
import RcSlider from "rc-slider"
import "rc-slider/assets/index.css"
import styles from "./index.module.scss"

export type SliderProps = {
  index: number
  total: number
  onChangeSlider: (value: number) => void
}

const MIN = 0
const STEP = 1

const handleStyle: React.CSSProperties = {
  background: "#ffffff",
  border: 0,
  boxShadow: "none",
  width: "12px",
  height: "12px",
}

const railStyle: React.CSSProperties = {
  background: "#ffffff",
  height: "2px",
}

const trackStyle: React.CSSProperties = {
  background: "#000",
  height: "2px",
}

const Slider: React.FC<SliderProps> = ({ index, total, onChangeSlider }) => {
  const showSlider = total > 1

  const formattedCurrentPageNumber = useMemo(() => {
    return (index + 1).toLocaleString()
  }, [index])

  const formattedTotalPageNumber = useMemo(() => {
    return total.toLocaleString()
  }, [total])

  const formattedProgressRate = useMemo(() => {
    if (!showSlider) {
      return null
    }

    return `${Math.floor((index / (total - 1)) * 100)}%`
  }, [index, showSlider, total])

  if (!showSlider) {
    return null
  }

  return (
    <div className={styles.sliderWrapper}>
      <RcSlider
        className={styles.slider}
        handleStyle={handleStyle}
        max={total - 1}
        min={MIN}
        railStyle={railStyle}
        step={STEP}
        trackStyle={trackStyle}
        value={index}
        reverse
        onChange={onChangeSlider}
      />
      <div className={styles.pageNumber}>
        <span>
          {formattedCurrentPageNumber}/{formattedTotalPageNumber}
        </span>
        <span className={styles.progressRate}>{formattedProgressRate}</span>
      </div>
    </div>
  )
}

export default Slider
